import { Component, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-form-file-image',
  templateUrl: './form-file-image.component.html',
  styleUrls: ['./form-file-image.component.scss']
})
export class FormFileImageComponent implements OnInit {

  @Input() imageData: string;
  @Input() alt: string = '';

  imageSrc$: Observable<string>;

  constructor(private imageService: ImageService) { }

  /**
   * 
   */
  ngOnInit(): void {
    if (this.imageData?.startsWith("STORAGE")) {
      const fileCode: string = this.imageData.split(':')[1];
      this.imageSrc$ = this.imageService.loadOne(fileCode);
    
    } else {
      this.imageSrc$ = of(this.imageData);
    }

  }

}
